import React, { useState, useEffect} from 'react';

import cloneDeep from 'lodash/cloneDeep';

import GlobalData from '../logic/GlobalData';

const useConstructor = (callBack = () => {}) => {
  const [hasBeenCalled, setHasBeenCalled] = useState(false);
  if (hasBeenCalled) return;
  callBack();
  setHasBeenCalled(true);
}

export default function Footer(props) {

  useConstructor(() => {

  }, []);

  
  return (
    <footer></footer>
  );
}